import React, { useState, useEffect, Suspense, useContext} from 'react';
import { GlobalCtx } from '../../context/GlobalContext';
import { HomePageCtx } from '../../context/HomeContext';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { COLORS, FONT_SIZE, MEDIA_QUERIES } from '../../Variables';
import { Helmet } from 'react-helmet-async';
import Loader from '../../components/Loader';

const HeaderMap = React.lazy(() => import('./HeaderMap'));
const HeaderSlider = React.lazy(() => import('./HeaderSlider'));
const Petition = React.lazy(() => import('./Petition'));
const TopicsMobileSlider = React.lazy(() => import('./TopicsMobileSlider'));
const Header = React.lazy(() => import('../../components/Header'));
const Footer = React.lazy(() => import('../../components/Footer'));
const DotsLoader = React.lazy(() => import('../../components/DotsLoader'));

const P = styled.p`
  display: flex;
  font-size: ${FONT_SIZE.title};
  font-weight: bold;
  max-width: 960px;
  margin: 40px auto 20px;
  @media ${MEDIA_QUERIES.TABLET} {
    font-size: ${FONT_SIZE.petition_title};
    line-height: 1.4;
    padding: 20px;
    background-color: ${COLORS.footerColor};
    margin: 0;
  }
`;

const HomePage = () => {
  const [cardTitle, setCardTitle] = useState('');

  const { lang } = useContext(GlobalCtx);
  const { loading, victoriesSlider } = useContext(HomePageCtx);
  const { t } = useTranslation();

  useEffect(() => {
    setCardTitle(lang === 'hazteoir' ? 'Hazte Oír' : 'CitizenGO');
  }, []);

  return (
    <>
      <Helmet>
        <title data-rh="true">{cardTitle}</title>
        <meta
          name="description"
          content={
            lang === 'hazteoir'
              ? 'Hazte Oír es una asociación miembro del grupo CitizenGO, cuyo objetivo es empoderar a los ciudadanos para generar cambios en España en favor de la vida, la familia y la libertad.'
              : 'CitizenGO is a community of active citizens that seeks to promote the participation of society in politics.'
          }
        />
        <meta
          property="og:description"
          content="CitizenGO is a community of active citizens that seeks to promote the participation of society in politics."
        />
        <meta property="og:title" content="CitizenGO" />
        <meta
          property="og:image"
          content="https://citizengo.org/static/media/cgo-new-mobile-logo.bf9346555bc4eda23cd0.webp"
        />
        <meta
          property="og:image:url"
          content="//citizengo.org/static/media/cgo-new-mobile-logo.bf9346555bc4eda23cd0.webp"
        />
        <meta
          property="og:image:secure_url"
          content="//citizengo.org/static/media/cgo-new-mobile-logo.bf9346555bc4eda23cd0.webp"
        />
        <meta property="og:type" content="article" />
        <meta property="og:site_name" content="CitizenGO" />
        <meta property="og:locale" content="en" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="CitizenGO" />
        <meta
          name="twitter:description"
          content="CitizenGO is a community of active citizens that seeks to promote the participation of society in politics."
        />
        <meta
          name="twitter:image"
          content="https://citizengo.org/static/media/cgo-new-mobile-logo.bf9346555bc4eda23cd0.webp"
        />
        <meta name="twitter:site" content="@CitizenGO" />
        <meta name="twitter:url" content="https://citizengo.org/en-us" />
      </Helmet>
      <Suspense fallback={<Loader />}>
        <Header />
        <HeaderMap />
        {victoriesSlider.length !== 0 && <HeaderSlider />}
        {loading && <DotsLoader />}
        <TopicsMobileSlider />
        <P>{t('petitions_list.title')}</P>
        <Petition />
        <Footer />
      </Suspense>
    </>
  );
};
// }

export default HomePage;
